import { useCommonEntryContext } from 'components_v2/common'
import Search from 'components_v2/Search'
import { useMeta, useTitle } from 'hooks/useMetaTitle'
import React from 'react'

const SearchView = () => {
  const { searchParams } = useCommonEntryContext()
  useTitle('Search')
  useMeta([
    {
      name: 'description',
      content: 'Search for Classes, Series, Instructors, Playlists, or Members'
    }
  ])

  const query = searchParams?.get('q') || ''

  return <Search query={query} />
}

export default SearchView
